import React from 'react'
import { Link } from 'react-router5'
import { CODE } from '../router/routes.js'

export const Root = () => (
  <Link className="enterButton" routeName={CODE}>Enter</Link>
)
